/**
 * @see https://github.com/ajaxorg/ace-builds/blob/master/ace-modules.d.ts
 */
export const ACE_THEME_NAMES = [
  'ambiance',
  'chaos',
  'chrome',
  'cloud9_day',
  'cloud9_night',
  'cloud9_night_low_color',
  'cloud_editor',
  'cloud_editor_dark',
  'clouds',
  'clouds_midnight',
  'cobalt',
  'crimson_editor',
  'dawn',
  'dracula',
  'dreamweaver',
  'eclipse',
  'github',
  'github_dark',
  'github_light_default',
  'gob',
  'gruvbox',
  'gruvbox_dark_hard',
  'gruvbox_light_hard',
  'idle_fingers',
  'iplastic',
  'katzenmilch',
  'kr_theme',
  'kuroir',
  'merbivore',
  'merbivore_soft',
  'mono_industrial',
  'monokai',
  'nord_dark',
  'one_dark',
  'pastel_on_dark',
  'solarized_dark',
  'solarized_light',
  'sqlserver',
  'terminal',
  'textmate',
  'tomorrow',
  'tomorrow_night',
  'tomorrow_night_blue',
  'tomorrow_night_bright',
  'tomorrow_night_eighties',
  'twilight',
  'vibrant_ink',
  'xcode',
] as const

export type AceThemeName = typeof ACE_THEME_NAMES[number]

export type LoadedAceTheme = {
  name: AceThemeName
  isDark: boolean
}

const loadedThemes = new Map<AceThemeName, LoadedAceTheme>()

export function getLoadedAceTheme(name: AceThemeName): LoadedAceTheme | undefined {
  return loadedThemes.get(name)
}

export async function loadAceTheme(name: AceThemeName): Promise<LoadedAceTheme> {
  const alreadyLoaded = loadedThemes.get(name)
  if (alreadyLoaded) return alreadyLoaded

  const module = await import(
    /* webpackInclude: /theme-[a-z0-9_]+\.js$/ */
    /* webpackChunkName: "ace-theme-[request]" */
    `ace-builds/src-noconflict/theme-${name}`
    ) as { isDark?: boolean }

  const theme: LoadedAceTheme = { name, isDark: Boolean(module.isDark) }
  loadedThemes.set(name, theme)
  return theme
}

